/**
 * Created by chongzi on 2017/9/26.
 */
// 判断arr是否为一个数组，返回一个bool值
import APPvue from './main.js'

let isArray = function (arr) {
  return Object.prototype.toString.call(arr) === '[object Array]'
}

// 深度克隆
export function deepClone (obj) {
  if (typeof obj !== 'object' && typeof obj !== 'function') {
    return obj
  }
  let o = isArray(obj) ? [] : {}
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i]
    }
  }
  return o
}

export function getAbsoluteUrl (url) {
  let a = document.createElement('A')
  a.href = url // 设置相对路径给Image, 此时会发送出请求
  url = a.href // 此时相对路径已经变成绝对路径
  return url
}

export function getBase64 (file, suc, err) {
  if (!file || file === undefined) return
  let reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = function () {
    if (suc) suc(reader.result)
  }
  reader.onerror = function (error) {
    // console.error('Error: ', error)
    if (err) err(error)
  }
}

export function getUrlParam (name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  let r = window.location.search.substr(1).match(reg);  //匹配目标参数
  if (r != null) return unescape(r[2]); return null; //返回参数值
}

export function isObjectValueEqual (a, b) {
  if (!a && !b) return true
  // Create arrays of property names
  let aProps = Object.getOwnPropertyNames(a)
  let bProps = Object.getOwnPropertyNames(b)

  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length !== bProps.length) {
    return false
  }

  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i]

    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true
}

export function __typeof__ (objClass) {
  if (objClass && objClass.constructor) {
    let strFun = objClass.constructor.toString()
    let className = strFun.substr(0, strFun.indexOf('('))
    className = className.replace('function', '')
    return className.replace(/(^\s*)|(\s*$)/ig, '')
  }
  return typeof (objClass)
}

export function toast (type, text, time) {
  APPvue.$vux.toast.show({
    time: time || 2000,
    text: text,
    width: '95%',
    position: 'top',
    type: type,
    isShowMask: true
  })
}
